import { UserLogoutService } from '~/lib/services/user-logout-service'
import { defineServiceComposable } from '~/composables/service-container'

export const useUserLogoutService = defineServiceComposable(
  'user-logout',
  () =>
    new UserLogoutService({
      clientCookieService: useClientCookieService(),
    }),
)
